// Order Comments API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type OrderCommentsRequests = {
    filterRequestAll: RequestConfigFunction<{
        orderNumber: string,
        data?: Record<string, any>,
    }>,
    createComment: RequestConfigFunction<{
        orderNumber: string,
        data?: Record<string, any>,
    }>,
    archiveComment: RequestConfigFunction<{
        id: number,
    }>,
}

const orderCommentsRequests: OrderCommentsRequests = {
    filterRequestAll: ({
        orderNumber,
        data = {},
    }) => {
        return {
            url: `order/${orderNumber}/comment/filter-request/all`,
            method: 'POST',
            data,
        }
    },
    createComment: ({
        orderNumber,
    }) => {
        return {
            url: `order/${orderNumber}/comment`,
            method: 'POST',
        }
    },
    archiveComment: ({
        id,
    }) => {
        return {
            url: `order/comment/${id}/archive`,
            method: 'PATCH',
        }
    },
}

export default orderCommentsRequests
